import React from 'react';
import {
    Form, Button
} from 'react-bootstrap';
import '../public/less/register.less';
import axios from 'axios';
import FormRow from './register/FormRow';
import CountrySelect from './register/CountrySelect';
import DropDown from './register/DropDown';
import BirthDate from './register/BirthDate';
import enums from '../config/enums';
import HoursRow from './register/HoursRow';
import { Load } from './common/basic';

var isSubmitPossible = false;

class Register extends React.Component {
    constructor(props) {
        super(props);

        var doctorID = this.props.params.userID;
        if (!doctorID) {
            doctorID = '';
        }
        this.state = {
            userID: doctorID,
            firstName: '',
            lastName: '',
            profession: '',
            status: this.props.route.status,
            userTypeID: this.props.params.userTypeID,
            password: '',
            imageUrl: '',
            file: ''
        };

        this.changeFirstName = this.changeFirstName.bind(this);
        this.changeLastName = this.changeLastName.bind(this);
        this.changeProfession = this.changeProfession.bind(this);
        this.changeUserImage = this.changeUserImage.bind(this);
        this.handleImageChange = this.handleImageChange.bind(this);
    }

    componentDidMount() {
        var doctorID = this.props.params.userID;
        if (this.state.status != "new") {
            var _this = this;
            this
                ._loading
                .Show();
            axios
                .get('/data/getAllDoctorData/' + doctorID)
                .then(function (data) {
                    var details = data.data.details;
                    _this.setState({
                        firstName: details.FirstName,
                        lastName: details.LastName,
                        profession: details.Profession,
                        imageUrl: data.data.userImage.url,
                        userTypeID: details.UserTypeID,
                        oldMobile: details.CellPhoneNumber
                    });
                    _this._firstName.changeValue(details.FirstName);
                    _this._lastName.changeValue(details.LastName);
                    _this._phone.changeValue(details.HomePhoneNumber);
                    _this._mobile.changeValue(details.CellPhoneNumber);
                    _this._email.changeValue(details.Email);
                    _this._userName.changeValue(details.Email);
                    _this._skype.changeValue(details.Skype);
                    _this._gender.changeValue(details.GenderID);
                    _this._street.changeValue(details.Street);
                    _this._city.changeValue(details.City);
                    _this._state.changeValue(details.State);
                    _this._country.changeValue(details.CountryID);
                    _this._zip.changeValue(details.Zip);
                    _this._profession.changeValue(details.Profession);
                    _this._birthDate.changeValue(details.BirthDate);
                    _this._userType.changeValue(details.UserTypeID);
                    _this._title.changeValue(details.Title);

                    var workingHours = data.data.workingHours;
                    for (var i = 0; i < workingHours.length; i++) {
                        var workingDay = workingHours[i];
                        var start = workingDay.Start;
                        var end = workingDay.End;
                        switch (workingDay.DayID) {
                            case 0:
                                _this._sunday.changeValue(start, end);
                                break;
                            case 1:
                                _this._monday.changeValue(start, end);
                                break;
                            case 2:
                                _this._tuesday.changeValue(start, end);
                                break;
                            case 3:
                                _this._wednesday.changeValue(start, end);
                                break;
                            case 4:
                                _this._thursday.changeValue(start, end);
                                break;
                            case 5:
                                _this._friday.changeValue(start, end);
                                break;
                            case 6:
                                _this._saturday.changeValue(start, end);
                                break;
                        }
                    }

                    _this
                        ._loading
                        .Hide();
                })
                .catch(function (error) {
                    if (error.response && error.response.data == "No permissions") {
                        window.location.replace("/login");
                    }
                    console.log(error);
                });
        }

    }

    validateAll(evt) {
        var isValid = true;
        if (!this._firstName.validate())
            isValid = false;
        if (!this._lastName.validate())
            isValid = false;
        if (!this._phone.validate())
            isValid = false;
        if (!this._mobile.validate())
            isValid = false;
        if (!this._email.validate())
            isValid = false;
        if (!this._skype.validate())
            isValid = false;
        if (!this._street.validate())
            isValid = false;
        if (!this._city.validate())
            isValid = false;
        if (!this._state.validate())
            isValid = false;
        if (!this._zip.validate())
            isValid = false;
        if (!this._profession.validate())
            isValid = false;
        if (!this._password_old.validate())
            isValid = false;
        if (!this._monday.validate())
            isValid = false;
        if (!this._tuesday.validate())
            isValid = false;
        if (!this._wednesday.validate())
            isValid = false;
        if (!this._thursday.validate())
            isValid = false;
        if (!this._friday.validate())
            isValid = false;
        if (!this._saturday.validate())
            isValid = false;
        if (!this._sunday.validate())
            isValid = false;

        // if (!this.validateBirthDate())
        //     isValid = false; 

        // email is taken
        if (isValid) {
            var _this = this;
            this._password_old.validatePassword(this.state.password, this.state.userID).then(function (passwordRes) {
                if (passwordRes) {


                    if (_this.state.status == "new") {
                        _this._email.validateEmail().then(function (emailRes) {
                            if (emailRes) {
                                _this._mobile.validateMobile().then(function (mobileRes) {
                                    if (mobileRes) {
                                        isSubmitPossible = true;
                                        _this
                                            ._submit
                                            .click();
                                    }
                                });
                            }
                        });
                    } else if (_this.state.status == "edit") {


                        if(_this._mobile.state.value == _this.state.oldMobile) {
                            isSubmitPossible = true;
                                _this
                                    ._submit
                                    .click();
                        } else {
                            _this._mobile.validateMobile(_this.state.oldMobile).then(function (mobileRes) {
                                if (mobileRes) {
                                    isSubmitPossible = true;
                                    _this
                                        ._submit
                                        .click();
                                }
                            });
                        }
                    } else {
                        isSubmitPossible = true;
                        _this
                            ._submit
                            .click();
                    }
                }
            });
        }
    }

    // validateBirthDate() {
    //     console.log('birthDate', this._birthDate);
    //     return true;
    // }


    beforeSubmit(evt) {
        if (!isSubmitPossible) {
            evt.preventDefault();
        }
    }

    setUserName(val) {
        this._userName.changeValue(val);
    }

    setNewPassword(val) {
        this.setState({ password: val });
        //    this._password.value(val);
    }

    redirectToEdit() {
        window.location.href = "/edit/" + this.props.params.userID;
    }

    redirectToRegister() {
        window.location.href = "/register";
    }

    changeFirstName(val) {
        this.setState({ firstName: val });
    }

    changeLastName(val) {
        this.setState({ lastName: val });
    }

    changeProfession(val) {
        this.setState({ profession: val });
    }

    changeUserImage() {
        if (this.state.status != 'show') {
            this.fileInput.click();
        }
    }

    handleImageChange(e) {
        e.preventDefault();

        let reader = new FileReader();
        let file = e.target.files[0];

        if (file && file != null) {
            reader.onloadend = () => {
                this.setState({
                    file: file,
                    imageUrl: reader.result
                });
            }

            reader.readAsDataURL(file);
        }
    }

    render() {
        var button;
        if (this.state.status == 'show') {
            button = <Button type="button" className='apply-filters btn btn-default' onClick={this.redirectToEdit.bind(this)}>
                EDIT PROFILE
            </Button>
        }
        else {
            button = <Button type="button" className='apply-filters btn btn-default' onClick={this.validateAll.bind(this)}>
                SAVE CHANGES
            </Button>
        }

        var fullName = this.state.firstName + ' ' + this.state.lastName;
        var imageUrl = this.state.imageUrl ? this.state.imageUrl : '/gallery/register/icon_expert_female.png';

        var errorPasswordChangeMsgStyle = {
            display: "none",
            color: "red",
            fontFamily: 'Karbon-Medium'
        };
        if (this.props.location.query.m) {
            errorPasswordChangeMsgStyle.display = "true";
        }

        var addUserClass = "apply-filters";
        if (this.state.userTypeID != enums.USER_TYPE.IT) {
            addUserClass = "hidden";
        }

        var workingHoursClass = "workingHours padding30";
        if (this.state.userTypeID != enums.USER_TYPE.DOCTOR) {
            workingHoursClass = "hidden";
        }

        var disabledControls = (this.props.params.userTypeID != enums.USER_TYPE.IT);

        return (
            <div className='background'>
                <Load
                    ref={(loading) => {
                        this._loading = loading;
                    }} />
                <div className='container'>
                    <Form horizontal method="post" onSubmit={this.beforeSubmit} encType="multipart/form-data">
                        <div className='col-xs-10'>

                            <div className='special-container'>
                                <div className='title'>
                                    <div className='float-left'>
                                        <img src={imageUrl} onClick={this.changeUserImage} />
                                        <input className="fileInput hidden" id="image" name="image"
                                            type="file" ref={(fileInput) => { this.fileInput = fileInput; }}
                                            onChange={this.handleImageChange} />
                                    </div>
                                    <div className='float-left name-title'>
                                        <h4>{this.state.profession}</h4>
                                        <div className='name'>{fullName}</div>
                                    </div>
                                    <div className='float-right'><Button className={addUserClass} onClick={this.redirectToRegister}>+ADD NEW USER</Button></div>
                                </div>
                                <hr />

                                <input type='hidden' id='userID' name='userID' value={this.state.userID} />
                                <div className='details'>
                                    <div className='col-xs-5'>
                                        <div className='personalDetails'>
                                            <h6>Personal Details</h6>
                                            <FormRow id="firstName" type="text" caption="First Name" Validators="name,notEmpty" ref={(firstName) => {
                                                this._firstName = firstName;
                                            }} status={this.state.status} onChange={this.changeFirstName} Value={this.state.firstName} />
                                            <FormRow id="lastName" type="text" caption="Surname" Validators="name,notEmpty" ref={(lastName) => {
                                                this._lastName = lastName;
                                            }} status={this.state.status} onChange={this.changeLastName} Value={this.state.lastName} />
                                            <FormRow id="phone" type="text" caption="Phone" Validators="numeric" ref={(phone) => {
                                                this._phone = phone;
                                            }} status={this.state.status} />
                                            <FormRow id="mobile" type="text" caption="Mobile" Validators="numeric,notEmpty,mobile" ref={(mobile) => {
                                                this._mobile = mobile;
                                            }} status={this.state.status} />
                                            <FormRow id="email" type="text" caption="E-mail" Validators="email,notEmpty,email" ref={(email) => {
                                                this._email = email;
                                            }} onChange={this.setUserName.bind(this)} status={this.state.status} changeable={false} />
                                            <FormRow id="skype" type="text" caption="Skype" ref={(skype) => {
                                                this._skype = skype;
                                            }} status={this.state.status} />
                                            <DropDown
                                                id="gender"
                                                caption="Gender"
                                                options={[
                                                    {
                                                        key: enums.USER_GENDER.MALE,
                                                        value: 'Male'
                                                    }, {
                                                        key: enums.USER_GENDER.FEMALE,
                                                        value: 'Female'
                                                    }
                                                ]} ref={(gender) => {
                                                    this._gender = gender;
                                                }} status={this.state.status} />
                                            <FormRow id="street" type="text" caption="Street & Num" Validators="notEmpty" ref={(street) => {
                                                this._street = street;
                                            }} status={this.state.status} />
                                            <FormRow id="city" type="text" caption="City" Validators="alpha,notEmpty" ref={(city) => {
                                                this._city = city;
                                            }} status={this.state.status} />
                                            <CountrySelect caption="Country" ref={(country) => {
                                                this._country = country;
                                            }} status={this.state.status} />
                                            <FormRow id="state" type="text" caption="State" Validators="alpha" ref={(state) => {
                                                this._state = state;
                                            }} status={this.state.status} />
                                            <FormRow id="zip" type="text" caption="Zip code" Validators="alphanumeric,notEmpty" ref={(zip) => {
                                                this._zip = zip;
                                            }} status={this.state.status} />
                                            <DropDown
                                                id="title"
                                                caption="Title"
                                                disabled={disabledControls}
                                                options={[
                                                    {
                                                        key: 'doctor',
                                                        value: 'Doctor'
                                                    }, {
                                                        key: 'super',
                                                        value: 'Super'
                                                    }
                                                ]} ref={(title) => {
                                                    this._title = title;
                                                }} status={this.state.status} />
                                            <FormRow id="profession" type="text" caption="Profession" Validators="alpha,notEmpty" ref={(profession) => {
                                                this._profession = profession;
                                            }} status={this.state.status} onChange={this.changeProfession} Value={this.state.profession} />
                                            <DropDown
                                                id="userType"
                                                caption="User Type"
                                                disabled={disabledControls}
                                                options={[
                                                    {
                                                        key: enums.USER_TYPE.DOCTOR,
                                                        value: 'Doctor'
                                                    }, {
                                                        key: enums.USER_TYPE.SUPER,
                                                        value: 'Super'
                                                    }, {
                                                        key: enums.USER_TYPE.IT,
                                                        value: 'IT'
                                                    }, {
                                                        key: enums.USER_TYPE.TRANSLATOR,
                                                        value: 'Translator'
                                                    }
                                                ]} ref={(userType) => {
                                                    this._userType = userType;
                                                }} status={this.state.status} />
                                            <BirthDate id='birthDate' caption="Birth Date" status={this.state.status} ref={(birthDate) => {
                                                this._birthDate = birthDate;
                                            }} />

                                            <div className='submit'>
                                                {button}
                                            </div>

                                        </div>

                                    </div>
                                    <div className='col-xs-5'>
                                        <div className='personalDetails'>
                                            <div style={errorPasswordChangeMsgStyle}>You must change your password to proceed</div>
                                            <h6>User Data</h6>
                                            <FormRow id="userName" type="text" caption="User name" disabled={true} ref={(userName) => {
                                                this._userName = userName;
                                            }} status={this.state.status} />
                                            <FormRow id="password_old" type="password" caption="Password" Validators='password' ref={(password_old) => { this._password_old = password_old; }}
                                                status={this.state.status} onChange={this.setNewPassword.bind(this)} placeHolder={(this.props.route.status == 'edit' || this.props.route.status == 'show') ? '****************' : ''} />
                                            <input type='hidden' id='password' name='password' value={this.state.password} />
                                        </div>

                                        <div className={workingHoursClass}>
                                            <h6>Working hours</h6>
                                            <HoursRow id="monday" day="Monday" status={this.state.status} ref={(monday) => {
                                                this._monday = monday;
                                            }} />
                                            <HoursRow id="tuesday" day="Tuesday" status={this.state.status} ref={(tuesday) => {
                                                this._tuesday = tuesday;
                                            }} />
                                            <HoursRow id="wednesday" day="Wednesday" status={this.state.status} ref={(wednesday) => {
                                                this._wednesday = wednesday;
                                            }} />
                                            <HoursRow id="thursday" day="Thursday" status={this.state.status} ref={(thursday) => {
                                                this._thursday = thursday;
                                            }} />
                                            <HoursRow id="friday" day="Friday" status={this.state.status} ref={(friday) => {
                                                this._friday = friday;
                                            }} />
                                            <HoursRow id="saturday" day="Saturday" status={this.state.status} ref={(saturday) => {
                                                this._saturday = saturday;
                                            }} />
                                            <HoursRow id="sunday" day="Sunday" status={this.state.status} ref={(sunday) => {
                                                this._sunday = sunday;
                                            }} />
                                        </div>
                                    </div>
                                </div>
                                <input
                                    type='submit'
                                    className='hidden'
                                    ref={(submit) => {
                                        this._submit = submit;
                                    }} />
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        )
    }
};

module.exports = Register;


// WEBPACK FOOTER //
// ./modules/register.jsx